var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83301 14.1667C2.83301 8.82412 2.83301 6.15284 4.49273 4.4931C6.15247 2.83337 8.82375 2.83337 14.1663 2.83337H19.833C25.1755 2.83337 27.8469 2.83337 29.5066 4.4931C31.1663 6.15284 31.1663 8.82412 31.1663 14.1667V15.5834C31.1663 19.5903 31.1663 21.5937 29.9215 22.8385C28.6767 24.0834 26.6732 24.0834 22.6663 24.0834H11.333C7.32606 24.0834 5.3226 24.0834 4.0778 22.8385C2.83301 21.5937 2.83301 19.5903 2.83301 15.5834V14.1667Z",
    stroke: "white",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 31.1666H11.333",
    stroke: "white",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.0834V31.1667",
    stroke: "white",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1663 18.4166H2.83301",
    stroke: "white",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonitor);
export default __webpack_public_path__ + "static/media/icon-monitor.e94001728013779ad15c96e60d0c70f7.svg";
export { ForwardRef as ReactComponent };